import React from 'react';

const CheckBox = () => {
  return <div className="border-1 w-27px h-10px" />;
};

export default CheckBox;
